(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[add-to-cart]');
    if (!btn) return;

    var id = parseInt(btn.getAttribute('add-to-cart'), 10);
    if (!id) return;

    // Read directly from the button's OHM-synced attributes
    var quantity = parseInt(btn.getAttribute('quantity'), 10) || 1;
    var planAttr = btn.getAttribute('selling-plan');
    var sellingPlanId = planAttr ? (parseInt(planAttr, 10) || null) : null;

    e.preventDefault();
    e.stopImmediatePropagation();

    var item = { id: id, quantity: quantity };
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    console.log('[Cart] Adding:', item);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function(r) {
      if (!r.ok) return r.text().then(function(t) { throw new Error(r.status + ': ' + t); });
      return r.json();
    }).then(function(addResp) {
      return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        return { addResp: addResp, cart: cart };
      });
    }).then(function(data) {
      // Fire the events this theme listens for
      document.dispatchEvent(new CustomEvent('cart:added',   { detail: data }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data.cart }));
      document.dispatchEvent(new CustomEvent('cart:changed', { detail: data.cart }));
    }).catch(function(err) {
      console.error('[Cart] Add failed:', err);
    });
  }, true);
})();


(function() {
  // Variant IDs capped at quantity 1
  var CAPPED_VARIANT_IDS = [50635684577593]; // Sampler Pack (US)

  var enforcing = false;

  function enforceCaps() {
    if (enforcing) return;
    enforcing = true;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var fixes = cart.items.filter(function(item) {
        return CAPPED_VARIANT_IDS.indexOf(item.variant_id) !== -1 && item.quantity > 1;
      });
      if (fixes.length === 0) { enforcing = false; return; }

      var updates = {};
      fixes.forEach(function(item) { updates[item.variant_id] = 1; });

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(r) { return r.json(); }).then(function(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:changed', { detail: cart }));
      });
    }).catch(function(err) {
      console.error('[Cart cap] failed:', err);
    }).finally(function() {
      enforcing = false;
    });
  }

  document.addEventListener('cart:added', enforceCaps);
  document.addEventListener('cart:updated', enforceCaps);
  document.addEventListener('cart:changed', enforceCaps);
})();